'use client';

import { useLoadingStore } from '@/stores/loadingStore';
import React from 'react';
import LoadingOverlay from 'react-loading-overlay-ts';
import ClipLoader from 'react-spinners/ClipLoader';

interface LoadingProps {
  children?: React.ReactNode;
  isFull?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({ children, isFull = true }) => {
  const { isLoading, content } = useLoadingStore();
  const [isReady, setIsReady] = React.useState(false);
  React.useEffect(() => {
    setIsReady(!!window);
  }, []);

  return (
    <LoadingOverlay
      active={isLoading}
      spinner={
        isReady && (
          <div>
            <ClipLoader color="#fff" />
            {content && <div style={{ marginTop: 10 }}>{content}</div>}
          </div>
        )
      }
      styles={{
        overlay: base => ({
          ...base,
          background: 'rgb(0 0 0 / 75%)',
          position: isFull ? 'fixed' : 'absolute',
        }),
      }}
    >
      {children}
    </LoadingOverlay>
  );
};
